import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SelectProviderService {
  public providerSelected$ = new Subject<any>();
}
